var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
export var getEnvPropagationTarget = function () { return __spreadArray(__spreadArray(__spreadArray([], (process.env.NODE_ENV === 'production' ? ['https://chuffed.org', 'https://chuffed.org/api'] : []), true), (process.env.NODE_ENV === 'staging' ? ['https://uat.chuffed.org', 'https://uat.chuffed.org/api'] : []), true), (process.env.NODE_ENV === 'development' ? [] : []), true); };
Sentry.init({
    dsn: 'https://4e6c807a9fa828c58da9fb87dd771bf1@o4508130513256448.ingest.de.sentry.io/4508130575384656',
    environment: process.env.NODE_ENV,
    integrations: [
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.reactRouterV6BrowserTracingIntegration({
            createRoutesFromChildren: createRoutesFromChildren,
            matchRoutes: matchRoutes,
            useEffect: useEffect,
            useLocation: useLocation,
            useNavigationType: useNavigationType,
        }),
        Sentry.replayIntegration(),
    ],
    // Capture Replay for 0% of all sessions with an error
    replaysOnErrorSampleRate: 0.0,
    // Capture Replay for 0% of all sessions
    replaysSessionSampleRate: 0.0,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: getEnvPropagationTarget(),
    // of transactions for tracing.
    // Set tracesSampleRate to 1.0 to capture 100%
    tracesSampleRate: 1.0,
});
export var createSentryErrorFromGraphQL = function (gqlError, errorName) {
    if (errorName === void 0) { errorName = null; }
    var errorTitle = errorName !== null && errorName !== void 0 ? errorName : (gqlError.message || 'GraphQL error');
    var sentryError = new Error(errorTitle);
    sentryError.name = errorTitle;
    return sentryError;
};
export var logGqlErrorToSentry = function (error, errorName) {
    if (errorName === void 0) { errorName = null; }
    Sentry.withScope(function (scope) {
        scope.setExtras({
            graphql_extensions: JSON.stringify(error.extensions, null, 2),
            graphql_original_error: error.originalError,
            graphql_path: error.path,
        });
        Sentry.captureException(createSentryErrorFromGraphQL(error, errorName));
    });
};
export var createSentryError = function (error, errorName) {
    if (errorName === void 0) { errorName = null; }
    var errorTitle = errorName !== null && errorName !== void 0 ? errorName : (error.message || 'Unexpected error');
    var sentryError = new Error(errorTitle);
    sentryError.name = errorTitle;
    return sentryError;
};
export var logErrorToSentry = function (error, errorName, extras) {
    if (errorName === void 0) { errorName = null; }
    if (extras === void 0) { extras = {}; }
    Sentry.withScope(function (scope) {
        scope.setExtras(extras);
        Sentry.captureException(createSentryError(error, errorName));
    });
};
